import type { IAssistantSharedNotificationData } from "@frontend-shared/types";
import { UserPlus } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IAssistantSharedCardProps {
  uuid: string;
  data: IAssistantSharedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewAssistants: (projectUuid: string) => void;
}

const AssistantSharedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewAssistants,
}: IAssistantSharedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewAssistants = useCallback(
    () => onViewAssistants(data.projectUuid),
    [onViewAssistants, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="assistant_shared"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserPlus className="h-5 w-5 text-indigo-500" />}
      iconBgClassName="bg-indigo-500/10"
      ctaLabel={t("view_assistants")}
      onCtaClick={handleViewAssistants}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.assistant_shared.body"
          values={{
            ownerName: data.ownerName,
            assistantName: data.assistantName,
            permissionLevel: data.permissionLevel,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const AssistantSharedCard = memo(AssistantSharedCardComponent);
